import { asset } from '../../../services/assetResolverService';
import { CSSProperties } from 'react';

type TClassIconProps = {
  class: string;
  title?: string;
  className?: string;
  size?: number;
  style?: CSSProperties;
};

const DEFAULT_SPRITE_SIZE = 64;

export function ClassIcon(props: TClassIconProps) {
  const { title, className, size, style } = props;

  if (!props.class) {
    return (
      <img
        src={asset('/images/questionmark.jpg')}
        className={className}
        title={title}
        alt="unknown class"
        style={size ? { width: size, height: size } : {}}
      />
    );
  }

  let scale: string = '1';
  if (size) {
    scale = String(size / DEFAULT_SPRITE_SIZE);
  }

  return (
    <div
      className="sprite-icon"
      style={{
        position: 'relative',
        overflow: 'hidden',
        ...style,
        ...(size ? { width: size, height: size } : {})
      }}
    >
      <div className="sprite-scaler" style={size ? { transform: `scale(${scale})` } : {}}>
        <div title={title} className={`class_${props.class}`} />
      </div>
    </div>
  );
}
